const initialState = {
  fingerprint: null
  // utm_campaign: 'newcampaign',
  // utm_source: 'utm source',
  // utm_medium: 'utm medium',
  // utm_content: 'utm content',
  // utm_term: 'utm term',
  // salesforce_uuid: 'sftrackinguuid'
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'INITIALIZE_FROM_URL':
      return {
        ...state,
        ...action.payload
      }
    case 'TRACK_FINGERPRINT':
      return {
        ...state,
        fingerprint: action.payload
      }
    case 'TRACK_STYTCH_TELEMETRY_ID':
      return {
        ...state,
        stytch_telemetry_id: action.payload.telemetryId,
        stytch_telemetry_expires_at: action.payload.expiresAt,
      }
    default:
      return state
  }
}
